import React, { useState, useEffect } from 'react';

import toast from 'react-hot-toast';

// reactstrap components
import {
  Card,
  CardHeader,
  Table,
  Container,
  Row,
  Button,
  Input,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Modal,
  CardBody,
  Form,
  Col,
} from 'reactstrap';
// core components
import Header from 'components/Headers/Header.js';

import { FaEdit, FaPlusCircle, FaTimesCircle } from 'react-icons/fa';
import Swal from 'sweetalert2';

import api from 'services/api';

import PropostaBancoModel from '../../../models/ConfiguradorBanco';

const ConfiguradorBanco: React.FC = () => {
  const [bancos, setBancos] = useState([] as PropostaBancoModel[]);
  // eslint-disable-next-line prettier/prettier
  const [bancosEditing, setBancosEditing] = useState({} as PropostaBancoModel);
  const [isEditing, setIsEditing] = useState(false);
  // const [isInserting, setIsInserting] = useState(false);

  const [formModalState, setFormModalState] = useState(false);
  const [modalStatusLogVisivel, setModalStatusLogVisivel] = useState(false);

  async function listaBancos() {
    const response = await api.get('/proposta-banco');

    setBancos(response.data);
  }

  useEffect(() => {
    sessionStorage.setItem('TelaConfig', '');
  }, []);

  useEffect(() => {
    listaBancos();
  }, []);

  async function handleDelete(bancoId: string) {
    Swal.fire({
      title: `Deseja excluir o registro?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `Sim`,
      confirmButtonColor: '#d33',
      cancelButtonText: `Não`,
    }).then(async result => {
      if (result.isConfirmed) {
        await api.delete(`/proposta-banco/${bancoId}`, {});
        Swal.close();
        toast.success('Registro excluído');
        listaBancos();
      }
    });
  }

  async function handleInsert() {
    setBancosEditing({} as PropostaBancoModel);
    setIsEditing(false);
    // setIsInserting(true);
    setFormModalState(!formModalState);
  }

  function handleUpdate(itemBanco: PropostaBancoModel) {
    setBancosEditing(itemBanco);
    // setIsInserting(false);
    setIsEditing(true);
    setFormModalState(!formModalState);
  }

  async function handleSaveBanco() {
    // eslint-disable-next-line prettier/prettier
    const { codigo, razaoSocial, nomeFantasia } = bancosEditing;

    if (!codigo || !razaoSocial) {
      toast.error(
        'Todos os campos marcados com * são de preenchimento obrigatório!',
      );
      return;
    }

    if (isEditing) {
      await api.put(`/proposta-banco/${bancosEditing.codigo}`, {
        codigo: bancosEditing.codigo,
        razaoSocial: bancosEditing.razaoSocial,
        nomeFantasia: bancosEditing.nomeFantasia,
      });
    } else {
      await api.post(`/proposta-banco`, {
        codigo: bancosEditing.codigo,
        razaoSocial: bancosEditing.razaoSocial,
        nomeFantasia: bancosEditing.nomeFantasia,
      });
    }

    toast.success('Registro concluído');
    setFormModalState(false);
    setBancosEditing({} as PropostaBancoModel);
    listaBancos();
  }

  return (
    <>
      <Header showCards={false} />
      {/* Page content */}
      <Container className="mt--7" fluid>
        <Row>
          <Col>
            <FormGroup className="mb-4">
              <InputGroup>
                <Button
                  className="btn-icon btn-2"
                  color="primary"
                  type="button"
                  onClick={handleInsert}
                >
                  <FaPlusCircle />
                </Button>
              </InputGroup>
            </FormGroup>
          </Col>
        </Row>

        {/* Table */}
        <Row>
          <div className="col">
            {/* Modal edição */}
            <Modal
              className="modal-dialog-centered"
              size="sm"
              isOpen={formModalState}
              toggle={() => setFormModalState(!formModalState)}
            >
              <div className="modal-body p-0">
                <Card className="bg-secondary shadow border-0">
                  <CardBody className="px-lg-5 py-lg-5">
                    <div
                      className="text-center text-muted mb-4"
                      hidden={!isEditing}
                    >
                      <small>{bancosEditing.codigo}</small>
                    </div>
                    <Form role="form">
                      <FormGroup className="mb-3" hidden={isEditing}>
                        <small>Código *</small>
                        <InputGroup className="input-group-alternative">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="ni ni-tag" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            placeholder="Código"
                            value={bancosEditing.codigo}
                            type="text"
                            disabled={isEditing}
                            onChange={text =>
                              setBancosEditing({
                                ...bancosEditing,
                                codigo: text.target.value,
                              })
                            }
                          />
                        </InputGroup>
                      </FormGroup>
                      <FormGroup className="mb-3">
                        <small>Razão Social *</small>
                        <InputGroup className="input-group-alternative">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="ni ni-tag" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            placeholder="Razão Social"
                            value={bancosEditing.razaoSocial}
                            type="text"
                            onChange={text =>
                              setBancosEditing({
                                ...bancosEditing,
                                razaoSocial: text.target.value,
                              })
                            }
                          />
                        </InputGroup>
                      </FormGroup>
                      <FormGroup className="mb-3">
                        <small>Nome Fantasia</small>
                        <InputGroup className="input-group-alternative">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="ni ni-tag" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            placeholder="Nome Fantasia"
                            value={bancosEditing.nomeFantasia}
                            type="text"
                            onChange={text =>
                              setBancosEditing({
                                ...bancosEditing,
                                nomeFantasia: text.target.value,
                              })
                            }
                          />
                        </InputGroup>
                      </FormGroup>

                      <div className="text-center">
                        <Button
                          className="my-4"
                          color="primary"
                          type="button"
                          onClick={handleSaveBanco}
                        >
                          Salvar
                        </Button>
                      </div>
                    </Form>
                  </CardBody>
                </Card>
              </div>
            </Modal>

            <Card className="shadow">
              <CardHeader className="border-0">
                <h3 className="mb-0">Lista de bancos</h3>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th>Código</th>
                    <th>Razão Social</th>
                    <th>Nome Fantasia</th>
                    <th>&nbsp;</th>
                  </tr>
                </thead>
                <tbody>
                  {bancos.map(itemBanco => (
                    <tr key={itemBanco.codigo}>
                      <td className="py-2">{itemBanco.codigo}</td>
                      <td className="py-2">{itemBanco.razaoSocial}</td>
                      <td className="py-2">{itemBanco.nomeFantasia}</td>
                      <td className="py-2">
                        <div className="float-right">
                          <Button
                            size="sm"
                            className="btn-icon"
                            color="warning"
                            type="button"
                            onClick={() => {
                              handleUpdate(itemBanco);
                            }}
                          >
                            <FaEdit />
                          </Button>
                          <Button
                            size="sm"
                            className="btn-icon"
                            color="danger"
                            type="button"
                            onClick={() => {
                              handleDelete(itemBanco.codigo);
                            }}
                          >
                            <FaTimesCircle />
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default ConfiguradorBanco;
